export function isAuthorStory(s) {
    return "chapters" in s;
}
//# sourceMappingURL=api.js.map